import { render, staticRenderFns } from "./custom-input.component.vue?vue&type=template&id=4b33fb6f&scoped=true&"
import script from "./custom-input.component.ts?vue&type=script&lang=ts&"
export * from "./custom-input.component.ts?vue&type=script&lang=ts&"
import style0 from "./custom-input.component.scss?vue&type=style&index=0&id=4b33fb6f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b33fb6f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
